export class NutritionUiLogic {
  public static getMamimumMealPrepTimeSliderStartingPoint(
     maximumMealPrepTimeLastSetByUser: number,
     mealPrepTimeUpperLimit: number,
     mealPrepTimeLowerLimit: number) {
       let maxMinutes;
       if (mealPrepTimeUpperLimit && mealPrepTimeLowerLimit) {
        if (maximumMealPrepTimeLastSetByUser) {
        if (mealPrepTimeUpperLimit < maximumMealPrepTimeLastSetByUser) {
        maxMinutes = mealPrepTimeUpperLimit;
        } else if (mealPrepTimeLowerLimit > maximumMealPrepTimeLastSetByUser) {
        maxMinutes = mealPrepTimeLowerLimit;
        } else {
        maxMinutes = maximumMealPrepTimeLastSetByUser;
        }
        } else {
        maxMinutes = mealPrepTimeUpperLimit;
        }
        }
       return maxMinutes;
  }
}
